import * as React from 'react';
import { clsx } from 'clsx';
import Layout from "./layout";

type Props = Readonly<{
	name: string
	className?: string,
	innerClassName?: string,
	children?: React.ReactNode
}>;

function MessageBox({
	name,
	children,
	className = '',
	innerClassName = ''
}: Props) {

	return (<>
		<Layout name={name}>
			<section className={clsx(className, "mx-auto relative max-w-screen-xl px-2 sm:px-4")}>
				<div className="bg-white text-black rounded-3xl overflow-hidden w-full h-full max-w-lg">
					<div className={clsx(innerClassName, "px-6 sm:px-8 py-12 w-full text-center")}>
						{children}
					</div>
				</div>
			</section>
		</Layout>
	</>);
}

export default MessageBox;
